import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
// import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json"
import translationAz from "./locales/az/translation.json"

i18n
  // .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    resources: {
      en: {
        translations: translationEn,
      },
      az: {
        translations: translationAz,
      }
    },
    detection: {
      order: ["path", "cookie"],
      caches: ["cookie"],
      cookieMinutes: 7 * 24 * 60 * 60 * 1000, //7 days
    },
    react: { useSuspense: false },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n